import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import Landing from "@/pages/Landing";
import Dashboard from "@/pages/Dashboard";
import DevisFactures from "@/pages/DevisFactures";
import DevisNew from "@/pages/DevisNew";
import DevisDetail from "@/pages/DevisDetail";
import FactureDetail from "@/pages/FactureDetail";
import Stocks from "@/pages/Stocks";
import ArticleDetail from "@/pages/ArticleDetail";
import Clients from "@/pages/Clients";
import ClientDetail from "@/pages/ClientDetail";
import Agenda from "@/pages/Agenda";
import ComptesRendus from "@/pages/ComptesRendus";
import Reglages from "@/pages/Reglages";
import Abonnement from "@/pages/Abonnement";
import PublicDevis from "@/pages/PublicDevis";
import { Cgv, Confidentialite } from "@/pages/Legales";
import { MotDePasseOublie, ReinitialiserMotDePasse } from "@/pages/MotDePasse";

function Protected() {
  const { user } = useAuth();
  if (user === undefined) {
    return (
      <div className="min-h-screen bg-[#12100D] flex items-center justify-center">
        <span className="font-serif text-[#D9A461] text-2xl">Mastoras</span>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  return <Layout />;
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Toaster position="top-center" richColors />
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/login" element={<Login />} />
          <Route path="/cgv" element={<Cgv />} />
          <Route path="/confidentialite" element={<Confidentialite />} />
          <Route path="/mot-de-passe-oublie" element={<MotDePasseOublie />} />
          <Route path="/reinitialiser-mot-de-passe" element={<ReinitialiserMotDePasse />} />
          <Route path="/devis/public/:token" element={<PublicDevis />} />
          <Route element={<Protected />}>
            <Route path="/tableau-de-bord" element={<Dashboard />} />
            <Route path="/devis" element={<DevisFactures />} />
            <Route path="/devis/nouveau" element={<DevisNew />} />
            <Route path="/devis/:id/modifier" element={<DevisNew />} />
            <Route path="/devis/:id" element={<DevisDetail />} />
            <Route path="/factures/:id" element={<FactureDetail />} />
            <Route path="/stocks" element={<Stocks />} />
            <Route path="/stocks/:id" element={<ArticleDetail />} />
            <Route path="/clients" element={<Clients />} />
            <Route path="/clients/:id" element={<ClientDetail />} />
            <Route path="/agenda" element={<Agenda />} />
            <Route path="/comptes-rendus" element={<ComptesRendus />} />
            <Route path="/entreprise" element={<Reglages />} />
            <Route path="/abonnement" element={<Abonnement />} />
          </Route>
          <Route path="*" element={<Navigate to="/tableau-de-bord" replace />} />
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
}
